import React from 'react';

const NotFound = () => (
  <div className="not-found">
    <p>Page Not found!</p>
    <p>Kindly confirm the link address!</p>
  </div>
);

export default NotFound;
